class Navigation {
    static goBack () {
        window.history.back();
    }
}

export default Navigation;
